import { t } from "@/i18n/booking";

// Pie con los datos de la empresa (LSSI, art. 10) y los enlaces al aviso legal, la privacidad y
// las condiciones. Dentro del widget (iframe) los enlaces abren pestaña nueva: esas páginas no se
// pueden incrustar (nginx.conf).
export default function LegalFooter({ lang = "es", brand, embedded = false }) {
  const titular = [
    brand?.legal_name || brand?.brand_name,
    brand?.tax_id ? `${t(lang, "tax_id")} ${brand.tax_id}` : "",
    brand?.address,
    brand?.email,
  ].filter(Boolean).join(" · ");
  const nueva = embedded ? { target: "_blank", rel: "noopener noreferrer" } : {};
  const enlaces = [
    ["/aviso-legal", "notice_title", "legal-footer-notice"],
    ["/privacidad", "privacy_title", "legal-footer-privacy"],
    ["/condiciones", "terms_title", "legal-footer-terms"],
  ];
  return (
    <footer className={`text-xs text-[#8A8A8A] ${embedded ? "px-4 pb-4" : "container-x py-6 border-t border-[#DCD8D0]"}`} data-testid="legal-footer">
      {!embedded && titular && <p className="mb-2" data-testid="legal-footer-company">{titular}</p>}
      <nav className="flex flex-wrap gap-x-4 gap-y-1">
        {enlaces.map(([ruta, clave, testid]) => (
          <a key={ruta} href={`${ruta}?lang=${lang}`} className="underline hover:text-marca" data-testid={testid} {...nueva}>
            {t(lang, clave)}
          </a>
        ))}
      </nav>
    </footer>
  );
}
